module.exports = __webpack_public_path__ + "static/media/home.eca158ad.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home.svg
// module id = 861
// module chunks = 0